var styles = {
  "Option": "Polaris-OptionList-Option",
  "SingleSelectOption": "Polaris-OptionList-Option__SingleSelectOption",
  "focused": "Polaris-OptionList-Option--focused",
  "active": "Polaris-OptionList-Option--active",
  "disabled": "Polaris-OptionList-Option--disabled",
  "select": "Polaris-OptionList-Option--select",
  "Media": "Polaris-OptionList-Option__Media",
  "Label": "Polaris-OptionList-Option__Label",
  "MultiSelectOption": "Polaris-OptionList-Option__MultiSelectOption",
  "CheckboxLabel": "Polaris-OptionList-Option__CheckboxLabel",
  "verticalAlignTop": "Polaris-OptionList-Option--verticalAlignTop",
  "verticalAlignCenter": "Polaris-OptionList-Option--verticalAlignCenter",
  "verticalAlignBottom": "Polaris-OptionList-Option--verticalAlignBottom",
  "Icon": "Polaris-OptionList-Option__Icon",
  "Checkbox": "Polaris-OptionList-Option__Checkbox"
};

export { styles as default };
